const apiUrl = process.env.VUE_APP_API_URL;
const googleLogin = `${apiUrl}/google-direct/`;
const googleClientID = process.env.VUE_APP_GOOGLE_CLIENT_ID

export const authService = {
  refreshToken,
  getToken,
  logout,
  fixCSRFToken,
  googleLogin,
  googleClientID,
  handleAuthCallback,
  checkAuthState
}

import axios from "axios";
import { userService  } from "./userService";

axios.defaults.xsrfCookieName = process.env.VUE_APP_CSRF_COOKIE_NAME
axios.defaults.xsrfHeaderName = "X-CSRFToken"
axios.defaults.withXSRFToken = true
axios.defaults.withCredentials = true;

function logout() {
  const logoutUrl = `${apiUrl}/accounts/logout/`
  window.location.href = logoutUrl
}

// Get access token
async function getToken(googleCode) {
  try {
    const res = await axios.post(`${apiUrl}/api-token-auth/`, {
      access_token: googleCode
    });
    if (res && res.data) {
      console.log("USER IS LOGGED");
      const accessToken = res.data.access_token;
      const refreshToken = res.data.refresh_token;
      if (accessToken) {
        console.log("added acc token to headers");
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + accessToken;
        const user = await userService.getUser();
      }
      if (refreshToken) window.localStorage.setItem("engrefresh", refreshToken);
      return res.data;
    }
  } catch (err) {
    console.log(err);
    return null
  }
}

async function fixCSRFToken() {
  try {
    console.log("Testing CSRF token..");
    // Use a simple health check endpoint instead
    const res = await axios.get(`${apiUrl}/health_check`)
  } catch (e) {
    if (e.response) {
      if (e.response.status == 403) {
        console.log("Token failed.");
        delete_cookie(process.env.VUE_APP_CSRF_COOKIE_NAME, "/", process.env.VUE_APP_CSRF_DOMAIN)
        delete_cookie("sessionid", "/", process.env.VUE_APP_CSRF_DOMAIN)
      }
    }
  }
}

function delete_cookie( name, path, domain ) {
  if( get_cookie( name ) ) {
    document.cookie = name + "=" +
      ((path) ? ";path="+path:"")+
      ((domain)?";domain="+domain:"") +
      ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
  }
}

function get_cookie(name){
  return document.cookie.split(';').some(c => {
      return c.trim().startsWith(name + '=');
  });
}
  
// Get token from refresh
async function refreshToken(refreshToken) {
  try {
    const res = await axios.post(`${apiUrl}/api-token-refresh/`, {
      refresh: refreshToken
    });
    if (res && res.data) {
      const accessToken = res.data.access;
      if (accessToken) {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + accessToken;

        const user = await userService.getUser();
      }
      return res.data;
    }
  } catch (err) {
    console.log(err);
    if (err.response) {
      if (err.response.status == 401 || err.response.status == 403) {
        window.localStorage.removeItem("engrefresh")
      }
    }
    // location.reload()
  }
}

// Handle authentication callback with tokens from URL
function handleAuthCallback() {
  const urlParams = new URLSearchParams(window.location.search);
  const accessToken = urlParams.get('access_token');
  const refreshToken = urlParams.get('refresh_token');
  const error = urlParams.get('error');

  if (error) {
    console.error('Auth callback error:', error);
    // Clear any existing tokens
    window.localStorage.removeItem("engrefresh");
    delete axios.defaults.headers.common["Authorization"];
    return { success: false, error };
  }

  if (accessToken && refreshToken) {
    console.log("Auth callback: Found tokens in URL");
    console.log("Auth callback: Access token (first 20 chars):", accessToken.substring(0, 20));
    console.log("Auth callback: Refresh token (first 20 chars):", refreshToken.substring(0, 20));
    
    // Store tokens
    window.localStorage.setItem("engrefresh", refreshToken);
    axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
    
    console.log("Auth callback: Stored refresh token in localStorage");
    console.log("Auth callback: Set Authorization header");
    console.log("Auth callback: localStorage now contains:", localStorage.getItem("engrefresh") ? "refresh token" : "no refresh token");
    
    // Clean URL
    const url = new URL(window.location);
    url.searchParams.delete('access_token');
    url.searchParams.delete('refresh_token');
    window.history.replaceState({}, document.title, url.toString());
    
    console.log("Auth callback: Tokens stored successfully");
    return { success: true, accessToken, refreshToken };
  }

  return { success: false, message: 'No tokens found' };
}

// Check current authentication state
async function checkAuthState() {
  const refreshTokenFromStorage = window.localStorage.getItem("engrefresh");
  
  if (refreshTokenFromStorage) {
    console.log("Auth state: Found refresh token, attempting to refresh access token");
    try {
      const result = await refreshToken(refreshTokenFromStorage);
      if (result && result.access) {
        console.log("Auth state: Successfully refreshed tokens");
        return { authenticated: true };
      } else {
        console.log("Auth state: Failed to refresh tokens");
        window.localStorage.removeItem("engrefresh");
        delete axios.defaults.headers.common["Authorization"];
        return { authenticated: false };
      }
    } catch (error) {
      console.error("Auth state: Error refreshing tokens:", error);
      window.localStorage.removeItem("engrefresh");
      delete axios.defaults.headers.common["Authorization"];
      return { authenticated: false };
    }
  }
  
  console.log("Auth state: No refresh token found");
  return { authenticated: false };
}



// WEBPACK FOOTER //
// ./src/services/authService.js